exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required[data-v-655f21f2]:after { content:\" *\";\n}\n.loader[data-v-655f21f2] {\n    border: 4px solid #f3f3f3; /* Light grey */\n    border-top: 4px solid #3498db; /* Blue */\n    border-radius: 50%;\n    width: 16px;\n    height: 16px;\n    margin: auto;\n    animation: spin-data-v-655f21f2 2s linear infinite;\n}\n@keyframes spin-data-v-655f21f2 {\n0% {\n        transform: rotate(0deg);\n}\n100% {\n        transform: rotate(360deg);\n}\n}\n", ""]);

// exports
